import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Link, useNavigate } from 'react-router-dom';

const RegisterForm = () => {
  const API_PREFIX = '/api';
  const { theme } = useTheme();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');  

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');  

    // Basic validation
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const response = await fetch(API_PREFIX + '/auth/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.detail || 'Registration failed');  
      }
  
   
      // Direct navigation to success page
      navigate('/registration-success');

    } catch (error) {
      console.error('Registration error:', error);
      setError(error.message);
    }
};

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label 
          htmlFor="email" 
          className="block text-sm font-medium mb-2"
          style={{ color: theme.mainPanelText }}
        >
          Email address
        </label>
        <input
          id="email"
          name="email"
          type="email"
          required
          value={formData.email}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2"
          style={{ 
            backgroundColor: theme.inputBg,
            borderColor: theme.inputBorder,
            color: theme.inputText
          }}
        />
      </div>

      <div>
        <label 
          htmlFor="password" 
          className="block text-sm font-medium mb-2"
          style={{ color: theme.mainPanelText }}
        >
          Password
        </label>
        <input
          id="password"
          name="password"
          type="password"
          required
          value={formData.password}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2"
          style={{ 
            backgroundColor: theme.inputBg,
            borderColor: theme.inputBorder,
            color: theme.inputText
          }}
        />
      </div>

      <div>
        <label 
          htmlFor="confirmPassword" 
          className="block text-sm font-medium mb-2"
          style={{ color: theme.mainPanelText }}
        >
          Confirm Password
        </label>
        <input
          id="confirmPassword"
          name="confirmPassword"
          type="password"
          required
          value={formData.confirmPassword}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2"
          style={{ 
            backgroundColor: theme.inputBg,
            borderColor: theme.inputBorder,
            color: theme.inputText
          }}
        />
      </div>

      {error && (
        <div className="text-red-500 text-sm">{error}</div>
      )}

      <button
        type="submit"
        className="w-full py-2 px-4 rounded-md font-medium focus:outline-none focus:ring-2 transition duration-150"
        style={{
          backgroundColor: theme.buttonBg,
          color: theme.buttonText,
        }}
      >
        Sign Up
      </button>

      <div className="mt-4 text-center">
        <span style={{ color: theme.mainPanelText }}>
          Already have an account?{' '}
        </span>
        <Link 
          to="/login" 
          className="font-medium"
          style={{ color: theme.accentColor }}
        >
          Sign In
        </Link>
      </div>
    </form>
  );
};

export default RegisterForm;